import { render, staticRenderFns } from "./TabSettingForm.vue?vue&type=template&id=4f0533e1&scoped=true&"
import script from "./TabSettingForm.vue?vue&type=script&lang=ts&"
export * from "./TabSettingForm.vue?vue&type=script&lang=ts&"
import style0 from "./TabSettingForm.vue?vue&type=style&index=0&id=4f0533e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0533e1",
  null
  
)

export default component.exports